<template>
    <div>
        The chatbot named <strong>{{ $_.get(activity, "payload.name") }}</strong> was deleted by
        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatbotDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
